import React from "react";
import { connect } from "react-redux";

import MALogin from "./MALogin";
import YesLogin from "../Customer/login";
import { checkRageRightByProps } from "../utils/functions";

class KundeLogin extends React.Component {
  render() {
    if (this.props.configStorage.isMaShop() && !checkRageRightByProps(this.props)) {
      return (
        <MALogin redirect={false} authenticated={this.props.authenticated}></MALogin>
      );
    } else if (!this.props.authenticationStorage.isSignedIn) {
      return (
        <YesLogin></YesLogin>
      );
    } else {
      return null;
    }
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage,
    rightStorage: store.rightStorage, // needed for checkRageRightByProps
    authenticationStorage: store.authenticationStorage,
  };
})(KundeLogin)
